import { BaseModel, attr, belongsTo } from "../../lib/itn-ui-kit/data";

export default class ProviderTypeModel extends BaseModel {
  static urlPath = "provider_types";

  @attr("string") name;
  @attr("string") estimatedAppointmentCount;
  @attr("boolean") sync;
  @attr("datetime") createdAt;
  @belongsTo("client") createdBy;
  @attr("datetime") updatedAt;
  @belongsTo("client") updatedBy;
}
